import React from 'react';
import { connect } from 'react-redux';
import { updateApplication } from '@redux/modules/application/actions';
import LinkButton from 'components/Form/LinkButton';
import SvgComponent from 'components/Form/SvgComponent';

export class NavigationToggle extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.props.dispatch(updateApplication('Settings', 'mobileNavigation', !this.isOpen()));
  }

  isOpen() {
    return this.props.settings.mobileNavigation || false;
  }

  render() {
    const open = this.isOpen();
    const title = open ? 'Close navigation' : 'Open navigation';
    const icon = `toggle-icon ${open ? 'xmark' : 'bars'}`;
    return (
      <LinkButton
        classContent="navigation-toggle mobile-visible"
        title={title}
        ariaLabel={title}
        ignoreLinkStyle
        ignorePaddingMargin
        onClick={() => this.toggle()}
      >
        <div className={icon} aria-hidden="true">
          <SvgComponent className={icon} src={open ? '/img/xmark.svg' : '/img/bars.svg'} />
        </div>
      </LinkButton>
    );
  }
}

function mapStateToProps(state) {
  const section = state.section || {};
  const app = state.application || {};
  const settings = app.Settings || {};
  const errors = app.Errors || {};
  const completed = app.Completed || {};
  return {
    application: app,
    settings,
    section,
    errors,
    completed,
  };
}

export default connect(mapStateToProps)(NavigationToggle);
